import { Component, inject, type OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import type { ThreadOrTaskMode } from '../../../server/types/message-types';

@Component({
  selector: 'app-inbox-thread-outlet',
  templateUrl: './inbox-thread-outlet.component.html',
  styleUrls: ['./inbox-thread-outlet.component.scss'],
  standalone: false,
})
export class InboxThreadOutletComponent implements OnInit {
  private route = inject(ActivatedRoute);

  orgId: string;
  threadId: string;
  mode: ThreadOrTaskMode;

  ngOnInit(): void {
    this.orgId = this.route.parent?.snapshot.params.orgId;
    this.threadId = this.route.snapshot.params.threadId;
    this.mode = this.route.snapshot.params.mode;
  }
}
